var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPresentation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "rgba(21,27,38,.75)",
    viewBox: "0 0 24 24",
    title: "presentation",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "MultiColorIcon-path--fadedBlack",
    d: "M12,0c-0.6,0-1,0.4-1,1H1C0.4,1,0,1.4,0,2s0.4,1,1,1h22c0.6,0,1-0.4,1-1s-0.4-1-1-1H13C13,0.4,12.6,0,12,0z M0,18c0-0.6,0.4-1,1-1h22c0.6,0,1,0.4,1,1s-0.4,1-1,1H13v1.3c0.6,0.3,1,1,1,1.7c0,1.1-0.9,2-2,2s-2-0.9-2-2c0-0.7,0.4-1.4,1-1.7V19 H1C0.4,19,0,18.6,0,18z M14,7c-0.6,0-1,0.4-1,1c0,0.6,0.4,1,1,1h6c0.6,0,1-0.4,1-1c0-0.6-0.4-1-1-1H14z M13,12c0-0.6,0.4-1,1-1h6 c0.6,0,1,0.4,1,1s-0.4,1-1,1h-6C13.4,13,13,12.6,13,12z M11,10c0,2.2-1.8,4-4,4s-4-1.8-4-4c0-2.2,1.8-4,4-4v4H11z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    className: "MultiColorIcon-path--white",
    d: "M23,3H1v14h22V3z M14,7c-0.6,0-1,0.4-1,1s0.4,1,1,1h6c0.6,0,1-0.4,1-1s-0.4-1-1-1H14z M13,12c0-0.6,0.4-1,1-1h6 c0.6,0,1,0.4,1,1s-0.4,1-1,1h-6C13.4,13,13,12.6,13,12z M11,10c0,2.2-1.8,4-4,4s-4-1.8-4-4c0-2.2,1.8-4,4-4v4H11z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPresentation);
export default __webpack_public_path__ + "static/media/presentation.fa48eca9.svg";
export { ForwardRef as ReactComponent };